import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http/http.service';
import { ParmedApiService as ParmedApi } from '../../core/api/parmed-api.service';
import { CMSPages } from '../../core/constants/app.constant';

@Injectable()
export class StaticContentService {
  constructor(private http: HttpService, private api: ParmedApi) {}
  getAemContent(url: string) {
    return this.http.get(url, { responseType: 'html' as 'json' });
  }
  getProductCatalog() {
    return this.http.get(this.api.Config.GET_PRODUCT_CATALOG_URL, {});
  }
}
